import axios from "axios";

const cleanParam = (value) => {
  if (value == null) return "";
  const text = String(value).trim();
  if (!text || text === "null" || text === "undefined") return "";
  return text;
};

export const downloadReceivePendingOrderReport = async (inputs = {}) => {
  const urlParams = new URLSearchParams();
  const from = cleanParam(inputs.from);
  const to = cleanParam(inputs.to);
  const year = cleanParam(inputs.year);
  const month = cleanParam(inputs.month);
  const factoryName = cleanParam(inputs.factory_name);
  const portNoAndName = cleanParam(inputs.port_no_and_name);
  const salesmanName = cleanParam(inputs.salesman_name);

  if (from) urlParams.set("from", from);
  if (to) urlParams.set("to", to);
  if (year) urlParams.set("year", year);
  if (month) urlParams.set("month", month);
  if (factoryName) urlParams.set("factory_name", factoryName);
  if (portNoAndName) urlParams.set("port_no_and_name", portNoAndName);
  if (salesmanName) urlParams.set("salesman_name", salesmanName);

  try {
    const config = {
      withCredentials: true,
      headers: {
        withCredentials: true,
      },
    };
    const query = urlParams.toString();
    const data = await axios.get(
      `${process.env.REACT_APP_URL}/api/reports/list-receive-pending-order-report-excel${
        query ? `?${query}` : ""
      }`,
      config,
    );
    const result = data?.data?.result;
    if (typeof result === "string" && /^https?:\/\//i.test(result.trim())) {
      return result.trim();
    }
    return null;
  } catch (error) {
    console.log(error);
    return null;
  }
};
